import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { OverviewSubawardsRow } from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewSubawardsRow";
import { getDefaultLineItems } from "store/actions/budgetBuilder";
import { convertByPeriodToByItem } from "utils/budgetBuilder";
import { budgetBuilderSelectors, tenantSelectors } from "store/selectors";


export const OverviewSubawards = () => {
	const periods = useSelector(budgetBuilderSelectors.periodRows);
	const fullSponsoredCostsByPeriod = useSelector(budgetBuilderSelectors.sponsoredCostsByPeriod);
	const categories = useSelector(tenantSelectors.proposalCategories);

	const subawardsByPeriod = useMemo(() => {
		let subawardsByPeriod = {};
		for (let period of periods) {
			const periodNumber = period.periodNumber;
			let sponsoredCostsForPeriod = fullSponsoredCostsByPeriod?.[periodNumber] || getDefaultLineItems(
				categories,
				period?.rateForPeriod
			);
			if (isNonEmptyArray(sponsoredCostsForPeriod)) {
				sponsoredCostsForPeriod = sponsoredCostsForPeriod?.filter(sponsoredCost => sponsoredCost?.value === "Subawards");
			}
			subawardsByPeriod[periodNumber] = sponsoredCostsForPeriod;
		}

		return subawardsByPeriod;
	}, [ categories, fullSponsoredCostsByPeriod, periods ]);

	const sponsoredCostsData = useMemo(
		() => convertByPeriodToByItem(subawardsByPeriod, periods.length, "value"),
		[ periods.length, subawardsByPeriod ],
	);

	return (
		<>
			{Object.entries(sponsoredCostsData).map(([ i, datum ]) => (
				<OverviewSubawardsRow
					key={i}
					hash={i}
					categoryData={datum}
					periods={periods}
				/>
			))}
		</>
	);
};
